import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 *  共享组件
 * */
	const login = r => require.ensure([], () => r(require('@/components/Login')), 'login')
	const erro = r => require.ensure([], () => r(require('@/components/404')), 'erro')
	const layout = r => require.ensure([], () => r(require('@/components/Layout')), 'layout')
	const home = r => require.ensure([], () => r(require('@/components/home')), 'home')
	const changelog = r => require.ensure([], () => r(require('@/components/Changelog')), 'changelog')
	const changepdata = r => require.ensure([], () => r(require('@/components/Changedata')), 'changepdata')

/**
 *  后台管理模块
 * */
	const admin = r => require.ensure([], () => r(require('@/pages/admin/admin')), 'admin')
	const role = r => require.ensure([], () => r(require('@/pages/admin/role/role')), 'role')
	const privilege = r => require.ensure([], () => r(require('@/pages/admin/privilege/privilege')), 'privilege')

/**
 * 客户关系模块
 * */
	const crm = r => require.ensure([], () => r(require('@/pages/crm/crm')), 'crm')
	const mouse = r => require.ensure([], () => r(require('@/pages/crm/mouse/mouse')), 'mouse')
	const agent = r => require.ensure([], () => r(require('@/pages/crm/agent/agent')), 'agent')
	const agentMange = r => require.ensure([], () => r(require('@/pages/crm/agent/agentmange')), 'agentmange')
	const order = r => require.ensure([], () => r(require('@/pages/crm/order/order')), 'order')
	const mouseactive = r => require.ensure([], () => r(require('@/pages/crm/mouseactive/mouseactive')), 'mouseactive')
	const userRecommendagent = r => require.ensure([], () => r(require('@/pages/crm/user/userRecommendagent')), 'userRecommendagent')
	const userApplyMouse = r => require.ensure([], () => r(require('@/pages/crm/user/userApplyMouse')), 'userApplyMouse')
	const userRelation = r => require.ensure([], () => r(require('@/pages/crm/user/userRelation')), 'userRelation')
	const mouseWaitAudit = r => require.ensure([], () => r(require('@/pages/crm/user/mousewaitaudit')), 'mouseWaitAudit')
	
/**
 * 基础数据模块
 * */
	const base = r => require.ensure([], () => r(require('@/pages/base/base')), 'base')
	const refenence = r => require.ensure([], () => r(require('@/pages/base/reference/reference')), 'reference')
	const teacher = r => require.ensure([], () => r(require('@/pages/base/teacher/teacher')), 'teacher')

/**
 * 机构管理模块
 * */
	const org = r => require.ensure([], () => r(require('@/pages/org/org')), 'org')
	const school = r => require.ensure([], () => r(require('@/pages/org/school/school')), 'school')
	const users = r => require.ensure([], () => r(require('@/pages/org/users/users')), 'users')
	const areaorg = r => require.ensure([], () => r(require('@/pages/org/area/areaorg')), 'areaorg')
	// 校管理员
	const pschool = r => require.ensure([], () => r(require('@/pages/org/admin/school')), 'school')

/* 公司信息管理 */
	const company = r => require.ensure([], () => r(require('@/pages/company/company')), 'company')
	const employees = r => require.ensure([], () => r(require('@/pages/company/employees/employees')), 'employees')

export default new Router({
	// mode: 'history',
  routes: [
  	{
        path: '/login',
        component: login,
    },
	{
        path: '/404',
        component: erro,
    },
    {
	    path: '/',
		meta: { auth: true },
	    component: layout,
	    children:[
	    	{
				path: '',
				redirect: '/home',
			},
			{
				path: '/home',
				meta: { auth: true },
				name: '首页',
				component: home
			},
			{
				path: '/crm',
				meta: { auth: true },
				component: crm,
				children:[
					{
						path: 'mouse',
						meta: { auth:true },
						name: '鼠标码',
						component: mouse
					},
					{
						path: 'agent',
						meta: { auth:true },
						name: '代理商',
						component: agent
					},
					{
						path: 'agentmange',
						meta: { auth:true },
						name: '代理商管理',
						component: agentMange
					},
					{
						path: 'order',
						meta: { auth:true },
						name: '订单信息',
						component: order
					},
					{
						path: 'order/:id',
						meta: { auth:true },
						name: '订单信息',
						component: order
					},
					{
						path: 'mouseactive',
						meta: { auth:true },
						name: '激活鼠标码',
						component: mouseactive
					},
					{
						path: 'newagentrecommender',
						meta: { auth:true },
						name: '老师推荐代理商列表',
						component: userRecommendagent
					},
					{
						path: 'newapply',
						meta: { auth:true },
						name: '老师申请设备列表',
						component: userApplyMouse
					},
					{
						path: 'userrelation',
						meta: { auth:true },
						name: '客户邀请关系查询',
						component: userRelation
					},
					{
						path: 'mousewaitaudit',
						meta: { auth:true },
						name: '鼠标待审核列表',
						component: mouseWaitAudit
					}
				]
			},
			{
				path: '/org',
				meta: { auth: true },
				component: org,
				children:[
					{
						path: 'school',
						meta: { auth:true },
						name: '学校管理',
						component: school
					},
					{
						path: 'users',
						meta: { auth:true },
						name: '用户管理',
						component: users
					},
					{
						path: 'area',
						meta: { auth:true },
						name: '区域管理组织机构管理',
						component: areaorg
					}
				]
			},
			{
				path: '/admin',
				meta: { auth:true },
				component: admin,
				children:[
					{
						path: 'role/privilege',
						meta: { auth:true },
						name: '权限分配',
						component: role
					},
					{
						path: 'privilege',
						meta: { auth:true },
						name: '权限管理',
						component: privilege
					}
				]
			},
			{
				path: '/base',
				meta: { auth:true },
				component: base,
				children:[
					{
						path: 'reference',
						meta: { auth:true },
						name: '教辅管理',
						component: refenence
					},
					{
						path: 'teacher',
						meta: { auth:true },
						name: '老师管理',
						component: teacher
					}
					// {
					// 	path: 'questionType',
					// 	meta: { auth:true },
					// 	name: '题型管理',
					// 	component: questionType
					// }
				]
			},
			{
				path:'/company',
				meta:{auth:true},
				component:company,
				children:[
					{
						path:'employees',
						meta:{auth:true},
						component:employees,
						name:'员工管理'
					}
				]
			},
			{
				path: '/changelog',
				meta: { auth:true },
				name: '更新日志',
				component: changelog
			},
			{
				path: '/changedata',
				meta: { auth:true },
				name: '修改资料',
				component: changepdata
			}
	    ]
    },
    {
    	path: '*',
    	redirect:'/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js